var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33332 27.3333V25.3333L12 23.3333V16L0.666656 19.3333V16.6666L12 9.99996V2.66663C12 2.11107 12.1944 1.63885 12.5833 1.24996C12.9722 0.86107 13.4444 0.666626 14 0.666626C14.5555 0.666626 15.0278 0.86107 15.4167 1.24996C15.8055 1.63885 16 2.11107 16 2.66663V9.99996L27.3333 16.6666V19.3333L16 16V23.3333L18.6667 25.3333V27.3333L14 26L9.33332 27.3333Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneIcon);
export default __webpack_public_path__ + "static/media/airplane_icon.b970c651a26738fa037dcd4df93139dd.svg";
export { ForwardRef as ReactComponent };